export default "__VITE_ASSET__DijCadaq__"